<!-- Description -->
<template>
    <div>
        <a-layout>
            <!-- 新增创建窗口 -->
            <a-modal :width="600" :maskClosable="false" okText="保存" title="新增村"
                     :visible="createVisible"
                     :confirm-loading="confirmLoading"
                     @ok="handleCreateOk" @cancel="handleCreateCancel">
                <a-form-model ref="createForm" :rules="rules" :model="createFormData">
                    <a-form-model-item label="地区选择" prop="addressSelect"
                                       :label-col="labelCol" :wrapper-col="wrapperCol" >
                        <address-default-ref placeholder="请选择地区"
                                             :provDisabled="addressDisabled.prov"
                                             :cityDisabled="addressDisabled.city"
                                             :countyDisabled="addressDisabled.county"
                                             :townDisabled="addressDisabled.town"
                                             :showVillage="false"
                                             :showDetail="false"
                                             model="col"
                                             v-model="createFormData.addressSelect">
                        </address-default-ref>
                    </a-form-model-item>
                    <a-form-model-item label="村名" prop="name" :label-col="labelCol" :wrapper-col="wrapperCol" >
                        <a-input v-model="createFormData.name" placeholder="请输入村名" :max-length="100" />
                    </a-form-model-item>
                </a-form-model>
            </a-modal>

            <!-- 查询工具栏 -->
            <a-row>
                <a-space size="small">
                    <address-default-ref placeholder="请选择地区"
                                         :provDisabled="addressDisabled.prov"
                                         :cityDisabled="addressDisabled.city"
                                         :countyDisabled="addressDisabled.county"
                                         :townDisabled="addressDisabled.town"
                                         :showVillage="false"
                                         :showDetail="false"
                                         v-model="addressSelect">
                    </address-default-ref>
                    <a-button type="primary" :disabled="loading" @click="resetAddressSelect">
                        清空地区选择
                    </a-button>
                    <a-button type="primary" class="ml-10" icon="search" :disabled="loading" @click="queryList(true)">
                        查询
                    </a-button>
                    <a-button type="danger" class="ml-10" icon="plus" :disabled="loading" @click="handleCreate(5)">
                        新增村
                    </a-button>
                </a-space>
            </a-row>

            <!-- 结果展示区 -->
            <a-row class="mt-20">
                <a-table bordered
                         :columns="mainTableColumns"
                         :data-source="mainTableList"
                         :loading="loading"
                         :pagination="pagination"
                         size="small"
                         rowKey="pkOrg"
                         @change="handleTableChange" >
                </a-table>
            </a-row>
        </a-layout>
    </div>
</template>

<script>
    // import api & component
    import ARow from "ant-design-vue/es/grid/Row";
    import {AddressDefaultRef} from '@/components';

    import {getOrgListByPage, addOrg} from '@/api/org';

    const mainTableColumns = [
        {
            title: '级别',
            dataIndex: 'orgType',
            align: 'center',
            customRender: function (data, row, index) {
                switch (data) {
                    case 1:
                        return "省级";
                    case 2:
                        return "市级";
                    case 3:
                        return "县级";
                    case 4:
                        return "乡级";
                    case 5:
                        return "村级";
                    default:
                        return "未知"
                }
            },
        },
        {
            title: '名称',
            dataIndex: 'name',
            align: 'center',
        },
        {
            title: '编码',
            dataIndex: 'code',
            align: 'center',
        },
        {
            title: '内编码',
            dataIndex: 'innercode',
            align: 'center',
        },
        // {
        //     title: '助记码',
        //     dataIndex: 'mnecode',
        //     align: 'center',
        // }
    ];

    export default {
        // 绑定自定义组件
        components: {
            ARow,
            AddressDefaultRef
        },
        data() {
            // 地址校验
            let checkAddress=(rule, value, callback)=>{
                if(!value){
                    this.$message.error("请选择地区信息");
                    return;
                }
                if(!value.prov || !value.prov.pkOrg){
                    callback(new Error("请选择省"));
                    return;
                }
                if(!value.city || !value.city.pkOrg){
                    callback(new Error("请选择城"));
                    return;
                }
                if(!value.county || !value.county.pkOrg){
                    callback(new Error("请选择县"));
                    return;
                }
                if(!value.town || !value.town.pkOrg){
                    callback(new Error("请选择乡镇"));
                    return;
                }
                callback();
            };
            return {
                // 查询加载中
                loading: false,
                // 分页配置
                pagination: {
                    show: false, current: 1, pageSize: 20, total: 0,
                    showQuickJumper: true, showSizeChanger: true, pageSizeOptions: ['10', '20', '50']
                },
                // 根据行政级别设置区划联动可用状态
                addressDisabled: {prov: false, city: false, county: false, town: false},
                addressSelect: {
                    prov: {pkOrg: undefined, name: undefined},
                    city: {pkOrg: undefined, name: undefined},
                    county: {pkOrg: undefined, name: undefined},
                    town: {pkOrg: undefined, name: undefined}
                },
                // 业务查询参数
                queryParam: {
                    scopeLevel: null,
                    scopeValue: null
                },
                // 列表表格配置
                mainTableColumns,
                mainTableList: [],
                // 创建表单
                createVisible: false,
                confirmLoading: false,
                labelCol: {span: 6},
                wrapperCol: {span: 14},
                createFormData: {
                    addressSelect: {
                        prov: {pkOrg: undefined, name: undefined},
                        city: {pkOrg: undefined, name: undefined},
                        county: {pkOrg: undefined, name: undefined},
                        town: {pkOrg: undefined, name: undefined}
                    },
                    pkParent: null,
                    orgType: null,
                    orgName: null,
                },
                // 表单校验规则
                rules:{
                    addressSelect: [
                        {validator: checkAddress, trigger: 'blur' },
                        {required: true, trigger: 'blur'},
                    ],
                    name: [
                        {required: true, message: '名称不能为空', trigger: 'blur'},
                        {min: 1, max: 50, message: '名称长度不能大于50', trigger: 'blur'},
                    ],
                },
            };
        },
        methods: {
            // 刷新区划选择
            resetAddressSelect() {
                let userInfo = this.$store.state.userInfo;
                let orgLevel = this.$store.state.orgLevel;
                this.addressDisabled.prov = (orgLevel >= 1);
                this.addressDisabled.city = (orgLevel >= 2);
                this.addressDisabled.county = (orgLevel >= 3);
                this.addressDisabled.town = (orgLevel >= 4);
                this.addressSelect = {
                    prov: {
                        pkOrg: orgLevel >= 1 ? userInfo.pkProvince : undefined,
                        name: orgLevel >= 1 ? userInfo.provinceName : undefined,
                    },
                    city: {
                        pkOrg: orgLevel >= 2 ? userInfo.pkCity : undefined,
                        name: orgLevel >= 2 ? userInfo.cityName : undefined,
                    },
                    county: {
                        pkOrg: orgLevel >= 3 ? userInfo.pkCounty : undefined,
                        name: orgLevel >= 3 ? userInfo.countyName : undefined,
                    },
                    town: {
                        pkOrg: orgLevel >= 4 ? userInfo.pkTown : undefined,
                        name: orgLevel >= 4 ? userInfo.townName : undefined,
                    },
                    village: {pkOrg: undefined, name: undefined}
                };
            },
            // 获取区划查询条件
            getOrgParam() {
                let _this = this;
                if (_this.addressSelect.town.pkOrg) {
                    _this.queryParam.scopeLevel = 4;
                    _this.queryParam.scopeValue = _this.addressSelect.town.pkOrg;
                } else if (_this.addressSelect.county.pkOrg) {
                    _this.queryParam.scopeLevel = 3;
                    _this.queryParam.scopeValue = _this.addressSelect.county.pkOrg;
                } else if (_this.addressSelect.city.pkOrg) {
                    _this.queryParam.scopeLevel = 2;
                    _this.queryParam.scopeValue = _this.addressSelect.city.pkOrg;
                } else if (_this.addressSelect.prov.pkOrg) {
                    _this.queryParam.scopeLevel = 1;
                    _this.queryParam.scopeValue = _this.addressSelect.prov.pkOrg;
                } else {
                    _this.queryParam.scopeLevel = null;
                    _this.queryParam.scopeValue = null;
                }
            },
            // 分页工具栏跳转
            handleTableChange(page, filters, sorter) {
                this.pagination.current = page.current;
                this.pagination.pageSize = page.pageSize;
                this.queryList(false);
            },
            // 执行查询
            queryList(firstPage) {
                let _this = this;
                if (firstPage) {
                    _this.pagination.current = 1;
                }
                _this.loading = true;
                _this.getOrgParam();
                _this.queryParam.pageNum = _this.pagination.current;
                _this.queryParam.pageSize = _this.pagination.pageSize;
                // 调用查询接口
                getOrgListByPage(_this.queryParam).then((response) => {
                    if (response.infoCode === 0) {
                        _this.mainTableList = response.data.records;
                        _this.pagination.total = response.data.total;
                    } else {
                        _this.$message.error(response.info);
                    }
                    _this.loading = false;
                }).catch((error) => {
                    if (error.response && error.response.status !== 500)
                        this.$message.error("系统异常，请稍后再试！");
                    _this.loading = false;
                });
            },
            // 新增业务
            handleCreate(orgType) {
                let _this = this;
                _this.createFormData = {};
                _this.createFormData.addressSelect = JSON.parse(JSON.stringify(_this.addressSelect));
                _this.createFormData.orgType = orgType;
                _this.createVisible = true;
            },
            handleCreateOk() {
                this.$refs.createForm.validate((valid) => {
                    let _this = this;
                    if (valid) {
                        _this.confirmLoading = true;
                        _this.createFormData.pkParent = _this.createFormData.addressSelect.town.pkOrg;
                        addOrg(_this.createFormData).then((response) => {
                            if (response.infoCode === 0) {
                                _this.createVisible = false;
                                _this.$message.success('保存成功');
                                _this.addressSelect = JSON.parse(JSON.stringify(_this.createFormData.addressSelect));
                                _this.queryList(true);
                            } else {
                                _this.$message.error('保存失败：' + response.info);
                            }
                            _this.confirmLoading = false;

                        }).catch((error) => {
                            _this.$message.error('系统异常，请稍后再试');
                            console.log('请求失败：' + error);
                            _this.confirmLoading = false;
                        });
                    }
                });
            },
            handleCreateCancel() {
                let _this = this;
                _this.createVisible = false;
                _this.confirmLoading = false;
                // 清空表单和校验
                _this.$refs.createForm.resetFields();
            },
        },
        computed: {},
        activated() {
            this.resetAddressSelect();
            this.queryList(true);
        }
    }
</script>

<style scoped>
    .mt-20 {margin-top: 20px;}
    .ml-20 {margin-left: 20px;}
    .ml-10 {margin-left: 10px;}

</style>